import React, { useState } from "react"
import VerticalLayout from "../../VerticalLayout/index"
import {
  Button,
  Row,
  Col,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  DropdownToggle,
} from "reactstrap"
import SweetAlert from "react-bootstrap-sweetalert"
import { useHistory } from "react-router-dom"
import moment from "moment/moment"

// Rating Plugin
import Rating from "react-rating"
// import RatingTooltip from "react-rating-tooltip"

import { JobContext } from "./JobContext"
import { useContext } from "react"
import { useEffect } from "react"

import { useLocation } from "react-router-dom"

import OrderStatusEnums from "../../../constants/orderStatusEnums.json"

function useQuery() {
  const { search } = useLocation()

  return React.useMemo(() => new URLSearchParams(search), [search])
}

const Job = () => {
  const history = useHistory()
  const JobModel = useContext(JobContext)
  const location = useLocation()
  let query = useQuery()
  const {
    orderDetails,
    getOrderDetails,
    customerRating,
    serviceProviderRating,
    orderStatus,
    setOrderStatus,
    customerDetails,
    editOderDetails,
    showSuccessAlert,
    setShowSuccessAlert,
    serviceProviderDetails,
    orderDate,
  } = JobModel
  const [singlebtn, setSinglebtn] = useState(false)
  const [def1, setDef1] = useState(null)
  const [def2, setDef2] = useState(null)
  const [customerReviewRatingCount, setCustomerReviewRatingCount] = useState(
    customerRating?.rating ? customerRating?.rating : null
  )
  const [serviceProviderRatingCount, setServiceProviderRatingCount] = useState(
    serviceProviderRating?.rating ? serviceProviderRating?.rating : null
  )

  const [customerComments, setCustomerComments] = useState("")
  const [servicProviderComments, setServiceProviderComments] = useState("")

  const [dropdownOpen, setDropdownOpen] = useState(false)
  const [submitChangeButtonStatus, setSubmitChangeButtonStatus] =
    useState(false)
  const [showSubmitDataAlert, setShowSubmitDataAlert] = useState(false)

  const saveUpdatedData = () => {
    setSubmitChangeButtonStatus(false)
    editOderDetails(
      location.search.split("?=")[1],
      customerReviewRatingCount,
      serviceProviderRatingCount,
      orderStatus
    )
  }

  const orderStatusArray = [
    OrderStatusEnums.OPEN,
    OrderStatusEnums.ASSIGNED,
    OrderStatusEnums.GO,
    OrderStatusEnums.STARTED,
    OrderStatusEnums.ONHOLD,
    OrderStatusEnums.RESUMED,
    OrderStatusEnums.COMPLETED,
    OrderStatusEnums.CANCELLED,
    OrderStatusEnums.PAID,
  ]

  const starStyle = {}

  const tooltipContent = ["Rate 1", "Rate 2", "Rate 3", "Rate 4", "Rate 5"]
  const tooltipContentMore = ["1", "2", "3", "4", "5", "6", "7", "8"]
  const tooltipContentHalf = ["6", "7", "8", "9", "10"]
  const tooltipContentMiddle = [
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "10",
    "11",
    "12",
  ]
  const tooltipContentStep = ["2", "4", "6", "8", "10"]
  const goBackButtonText = "< Back"

  useEffect(() => {
    getOrderDetails(location.search.split("?=")[1])
  }, [])

  useEffect(() => {
    setCustomerReviewRatingCount(
      customerRating?.rating ? customerRating?.rating : 0
    )
    setServiceProviderRatingCount(
      serviceProviderRating?.rating ? serviceProviderRating?.rating : null
    )

    setCustomerComments(
      customerRating?.comment
        ? customerRating?.comment
        : serviceProviderRating?.userComment
    )
    setServiceProviderComments(serviceProviderRating?.jobComment)
  }, [orderDetails, serviceProviderRating])

  return (
    <VerticalLayout>
      <div style={{ marginTop: "70px" }} className="p-4">
        <Button
          className="bg-dark text-white mt-5 mb-5"
          onClick={() => history.goBack()}
        >
          {goBackButtonText}
        </Button>
        <Row className="align-items-center p-3">
          <Col>
            <h6 className="m-0 font-size-16 ">
              {" "}
              <h5>Order Id :</h5>
              <h6 style={{ fontWeight: 400 }}>
                <h2>{orderDetails?.orderId}</h2>
              </h6>
            </h6>
            <div>
              <h5>Customer Name :</h5>
              {customerDetails?.name && (
                <h6 style={{ fontWeight: 400 }}>{customerDetails?.name}</h6>
              )}
            </div>
            <div>
              {orderDetails?.customer?.name && (
                <strong>{orderDetails?.customer?.name}</strong>
              )}
            </div>
            <div>
              <h5>Customer Id :</h5>
            </div>
            <div>
              {orderDetails?.userId && (
                <h6 style={{ fontWeight: 400 }}>{orderDetails?.userId}</h6>
              )}
            </div>
            <div>
              <h5>Date :</h5>
            </div>
            <div>
              {orderDetails?.updatedAt && (
                <h6 style={{ fontWeight: 400 }}>
                  {moment(orderDetails?.updatedAt.seconds)
                    .utcOffset("+05:30")
                    .format("h:mm:ss a, DD/MM/YYYY")}
                </h6>
              )}
            </div>
          </Col>
          <Col>
            {/* <Button
              color="danger"
              className="btn btn-danger waves-effect waves-light"
            >
              Block User
            </Button>{" "} */}
            <h5>Email :</h5>
            {customerDetails?.email && <div>{customerDetails?.email}</div>}
            <h5>Customer Comments:</h5>
            {customerComments && <div>{customerComments}</div>}
            <h5>Partner Comments:</h5>
            {servicProviderComments && <div>{servicProviderComments}</div>}
          </Col>
        </Row>
        <Row className="align-items-center p-3">
          <Col>
            <h5>Service Address :</h5>
            <div>
              <strong>Name: </strong> {customerDetails?.serviceAddress?.name}
            </div>
            <div>
              {" "}
              <strong>Latitdue: </strong>{" "}
              {customerDetails?.serviceAddress?.latitude}
            </div>
            <div>
              <strong> Longitude: </strong>{" "}
              {customerDetails?.serviceAddress?.longitude}
            </div>
            <div>
              <strong> Address: </strong>{" "}
              {customerDetails?.serviceAddress?.address}
            </div>
            <div>
              <strong>Pin code:</strong>{" "}
              {customerDetails?.serviceAddress?.pincode}
            </div>
          </Col>
          <Col>
            <h5>Job Type :</h5>
            {orderDetails?.name && <div>{orderDetails?.name}</div>}
          </Col>
        </Row>

        <Row className="align-items-center p-3">
          <Col>
            <h5>Order Status :</h5>
            <Col sm={6}>
              <Dropdown
                isOpen={dropdownOpen}
                toggle={() => setDropdownOpen(!dropdownOpen)}
              >
                <DropdownToggle className="btn btn-secondary" caret>
                  {orderStatus} <i className="mdi mdi-chevron-down" />
                </DropdownToggle>
                <DropdownMenu>
                  {orderStatusArray.map(item => (
                    <DropdownItem
                      value={item}
                      onClick={e => {
                        setOrderStatus(e.target.value)
                        setSubmitChangeButtonStatus(true)
                      }}
                    >
                      {item}
                    </DropdownItem>
                  ))}
                </DropdownMenu>
              </Dropdown>
            </Col>
          </Col>
          <Col>
            <h5>Job Details :</h5>
            {orderDetails?.selectedParticulars &&
              orderDetails.selectedParticulars.map((item, index) => (
                <div>
                  {index + 1}. {item}
                </div>
              ))}
          </Col>
        </Row>
        <Row className="align-items-center p-3">
          <Col>
            <h5>Partner details :</h5>
            <div>
              <strong> Name: </strong> {serviceProviderDetails?.name}
            </div>
            <div>
              <strong> Email: </strong> {serviceProviderDetails?.email}
            </div>
            <div>
              <strong> Phone: </strong> {serviceProviderDetails?.phone}
            </div>
          </Col>
        </Row>
        <Row className="align-items-center p-3">
          <Col xl="3" md="4" sm="6">
            <div className="p-4 text-center">
              <h5 className="font-16 m-b-15">Customer Review</h5>
              {/* <RatingTooltip
                max={5}
                defaultRating={customerRating?.rating}
                onChange={rate => {
                  setDef1(rate)
                }}
                active={4}
                tooltipContent={tooltipContent}
                ActiveComponent={
                  <i
                    key={"active_6"}
                    className="mdi mdi-star text-primary"
                    style={starStyle}
                  />
                }
                InActiveComponent={
                  <i
                    key={"active_06"}
                    className="mdi mdi-star-outline text-muted"
                    style={starStyle}
                  />
                }
              /> */}
              <Rating
                start={0}
                stop={5}
                initialRating={customerReviewRatingCount}
                onChange={rating => {
                  setCustomerReviewRatingCount(rating)
                  setSubmitChangeButtonStatus(true)
                }}
              />
            </div>
          </Col>
          <Col xl="3" md="4" sm="6">
            <div className="p-4 text-center">
              <h5 className="font-16 m-b-15">Partner Review</h5>
              <Rating
                start={0}
                stop={5}
                initialRating={serviceProviderRatingCount}
                onChange={rating => {
                  setServiceProviderRatingCount(rating)
                  setSubmitChangeButtonStatus(true)
                }}
              />
              {/* <RatingTooltip
                max={5}
                onChange={rate => {
                  setDef2(rate)
                }}
                tooltipContent={tooltipContent}
                ActiveComponent={
                  <i
                    key={"active_6"}
                    className="mdi mdi-star text-primary"
                    style={starStyle}
                  />
                }
                InActiveComponent={
                  <i
                    key={"active_06"}
                    className="mdi mdi-star-outline text-muted"
                    style={starStyle}
                  />
                }
              /> */}
            </div>
          </Col>
          <Col xl="3" md="4" sm="6" />
          <div
            style={{
              width: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {submitChangeButtonStatus && (
              <Button
                className="bg-dark text-white mt-5 mb-5"
                disabled={!submitChangeButtonStatus}
                onClick={() => history.goBack()}
              >
                Cancel
              </Button>
            )}

            <Button
              className="bg-success text-white mt-5 mb-5"
              disabled={!submitChangeButtonStatus}
              onClick={() => setShowSubmitDataAlert(true)}
            >
              Submit
            </Button>
          </div>
        </Row>
      </div>
      {/* {ALERT FOR UPDATE ORDER DETAILS} */}
      <SweetAlert
        warning
        // show={showDeletePartnerAlert}
        showCancel
        show={showSubmitDataAlert}
        confirmBtnText="Confirm"
        confirmBtnBsStyle={"danger"}
        title={"Are you sure want to save the changes ?"}
        onConfirm={() => {
          saveUpdatedData()
          setShowSubmitDataAlert(false)
        }}
        onCancel={() => {
          setShowSubmitDataAlert(false)
        }}
        focusCancelBtn
      ></SweetAlert>
      {/*SUCCESS ALERT FOR COMMON */}
      <SweetAlert
        success
        show={showSuccessAlert}
        confirmBtnText="Ok"
        confirmBtnBsStyle={"success"}
        title={"Success"}
        onConfirm={() => {
          setShowSuccessAlert(false)
          setShowSubmitDataAlert(false)
        }}
      ></SweetAlert>
    </VerticalLayout>
  )
}

export default Job
